import React, { useState, Suspense, lazy, useEffect, useCallback } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Location, Redirect } from "@reach/router";
import { useLocation } from "react-router-dom";

import Mint from "../pages/Landing";
import ComingSoon from "../pages/ComingSoon";
import Swap from "../pages/Swap";
import Game from "../pages/game";
import Store from "../pages/store";
import Toxic from "../pages/Toxic";
import ItemDetail from "../pages/ItemDetail";
import AuctionDetail from "../pages/AcceptBid";
import Home2 from "../pages/home2";

import { Typography } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../hooks/redux";

const Home = lazy(() => import("../pages/Home"));
const Dashboard = lazy(() => import("../pages/Dashboard"));
const Poolboard = lazy(() => import("../pages/Poolboard"));




const Body = () => {

  const { isConnectedWallet, poolId, isCurrentNetwork } = useAppSelector(
    (state) => state.DashboardReducer
  );

  const isShowPoolboard = React.useMemo(
    () => isConnectedWallet && isCurrentNetwork,
    [isConnectedWallet, isCurrentNetwork]
  );

  return (
    <div className="col-sm-12 right d-flex justify-content-center  right-menu">
      <Routes>
        <Route
          path="/Game"
          element={
            <Suspense fallback={<Typography>Loading...</Typography>}>
              <Game path="/Game" />
            </Suspense>
          }
        />

        <Route
          path="/"
          element={
            <Suspense fallback={<Typography>Loading...</Typography>}>
              <Mint path="/" />
            </Suspense>
          }
        />
        <Route
          path="/Store"
          element={
            <Suspense fallback={<Typography>Loading...</Typography>}>
              <ComingSoon path="/ComingSoon" />
            </Suspense>
          }
        />

        <Route
          path="/Toxic"
          element={
            <Suspense fallback={<Typography>Loading...</Typography>}>
              <Toxic path="/Toxic" />
            </Suspense>
          }
        />
        <Route
          path="/MarketPlace"
          element={
            <Suspense fallback={<Typography>Loading...</Typography>}>
              <Home2 path="/MarketPlace">
                <Redirect to="/home2" />
              </Home2>
            </Suspense>
          }
        />
        <Route
          path="/ItemDetail"
          element={
            <Suspense fallback={<Typography>Loading...</Typography>}>
              <ItemDetail path="/ItemDetail">
                <Redirect to="/ItemDetail" />
              </ItemDetail>
            </Suspense>
          }
        />
        <Route
          path="/ComingSoon"
          element={
            <Suspense fallback={<Typography>Loading...</Typography>}>
              <ComingSoon path="/ComingSoon" />
            </Suspense>
          }
        />
        <Route
          path="/ssss"
          element={
            <Suspense fallback={<Typography>Loading...</Typography>}>
              <Swap path="/Swap" />
            </Suspense>
          }
        />

        <Route
          path="/AuctionDetail"
          element={
            <Suspense fallback={<Typography>Loading...</Typography>}>
              <AuctionDetail path="/AuctionDetail" />
            </Suspense>
          }
        />

        <Route
          path="/poolboard"
          element={
            <Suspense fallback={<Typography>Loading...</Typography>}>
              <Poolboard isShowPoolboard={isShowPoolboard} />
            </Suspense>
          }
        />
        <Route
              path="/dashboard"
              element={
                <Suspense fallback={<Typography>Loading...</Typography>}>
                  <Dashboard poolId={poolId} />
                </Suspense>
              }
            />
      </Routes>
    </div>
  );
};

export default Body;
